import gql from 'graphql-tag';
import fragments from '../fragments.js';

export default {
    identifyClasses: gql`
        query IdentifyClasses($setID: String!, $postIDs: [String!]!) {
            identifyClasses(setID: $setID, postIDs: $postIDs) {
                ... on IdentifyClassesResponse {
                    identified {
                        ...IdentifiedClassesFragment
                    }
                }
            }
        }

        ${fragments.identifiedClass}
        ${fragments.identifiedClasses}
    `,
};
